require('./authorizationModifyAccount.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ helpers
const { formatText, FormattedText, getFinalTitle, getLanguage } = require('core/i18n').i18n;
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';
// @ actions
import {
    changeSelectedAccount,
    modifyAcount,
    setVisibleStep,
    validateStep,
    modifyAccountReset
} from 'actions/accountDebits/authorizationModifyAccount';
import { validateAndExecuteSagas } from 'actions/signaturePattern';
// @components
import DropdownAccounts from 'components/dropdownAccounts/dropdownAccounts';
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
// @ Commons
import { SignaturePattern } from 'components/signaturePattern/signaturePattern';
import Wizard from 'components/commons/wizard/wizard';
import WizardStep from 'components/commons/wizardStep/wizardStep';
import WizardError from 'components/commons/wizardError/wizardError';
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
// @ constants
const { AUTHORIZATION_MODIFY_ACCOUNT } = require('constants/operationTypes');
// @utilities
import { getCurrentAccounts } from 'utilities/currentAccountsHelper.js';
const { getLastNChars } = require('utilities/stringHelper');

class AuthorizationModifyAccount extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        this.props.modifyAccountReset();
    }

    breadcrumb = (accountId) => {
        return [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: formatText('breadcrumb-debits'),
                url: `/myprofile/accounts/${accountId}/debits`
            },
            {
                text: formatText('breadcrumb-authorizationModifyAccount'),
                url: ''
            }
        ];
    }

    handleCancel = () => {
        const { match: { params: { accountId } }, history } = this.props;
        history.push(`/myprofile/accounts/${accountId}/debits`);
    }

    handleFinish = () => {
        const {
            immAccounts,
            immAuthorizations,
            immAuthorizationModifyAccount,
            modifyAcount,
            match: { params: { accountId, authorizationId } },
            validateAndExecuteSagas
        } = this.props;
        const detinationAccountId = immAuthorizationModifyAccount.get('accountId');
        const account = immAccounts.getIn(['byId', detinationAccountId]);
        const authorization = immAuthorizations.getIn([accountId, 'byId', authorizationId]);
        const authCode = authorization.getIn(['claveAviso', 'codinternogau']);
        const authType = authorization.getIn(['claveAviso', 'tipoautorizaciongau', 'codalfanum']);
        const newProduct = account.get('newProduct');
        const newContractNumber = account.get('newContractNumber');
        validateAndExecuteSagas((dispatch, getState, dataToken) => {
            modifyAcount(newProduct, newContractNumber, authCode, authType, dataToken, accountId, detinationAccountId);
        })
    }

    handleAccountChange = (accountId) => {
        const { changeSelectedAccount } = this.props;
        changeSelectedAccount(accountId)
    }

    renderWizardError = (exitLink) => {
        const goBackButton = {
            label: formatText('authorizationModifyAccount-backToDebits'),
            url: exitLink
        }
        return (
            <WizardError
                errorMessage={formatText('authorizationModifyAccount-errorTitle')}
                mainButton={goBackButton}
            >
                <p>
                    <FormattedText value="authorizationModifyAccount-errorSubTitle" />
                </p>
            </WizardError>
        )
    }

    getOriginAccountParam = (destinationAccount) => {
        return destinationAccount && `00730100${destinationAccount.get('newProduct')}${destinationAccount.get('newContractNumber')}`
    }

    renderAmmount = (balance) => {
        const plainAmountObject = getPlainAmountObject(balance);
        return (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
        )
    }

    renderCurrentInfoAccount = (accountInCharge, name) => {
        const { immAccount } = this.props;
        return (
            <OKInformativeList columns={3}>
                <OKInformativeListItem
                    title={formatText('authorizationModifyAccount-currentAccount')}
                    bodyText={accountInCharge}
                />
                <OKInformativeListItem
                    title={formatText('authorizationModifyAccount-beneficiaryName')}
                    bodyText={name}
                />
                <OKInformativeListItem
                    title={formatText('authorizationModifyAccount-amount')}
                    bodyText={this.renderAmmount(immAccount.get('balance'))}
                />
            </OKInformativeList>
        )
    }

    renderStep1 = (accountInCharge, immAccount, destinationAccountId, immAuthorizationModifyAccount, accountId, immAccounts, originAccountName) => {
        const { immAuthorizations, match: { params: { authorizationId } } } = this.props;
        const company = immAuthorizations.getIn([accountId, 'byId', authorizationId, 'nombreActuante']);
        const accountsById = immAccounts.get('byId');
        const accountsIndexes = getCurrentAccounts(immAccounts.get('byOrder').toJS(), accountsById);

        return (
            <div>
                <div className="authorization-modify-account__title">
                    <FormattedText value="authorizationModifyAccount-title" />
                </div>
                <div className="authorization-modify-account__text">
                    <FormattedText value="authorizationModifyAccount-text" injectedStrings={[company]} />
                </div>
                <div className="authorization-modify-account__header-container">
                    {this.renderCurrentInfoAccount(accountInCharge, originAccountName)}
                </div>
                <DropdownAccounts
                    label={formatText('authorizationModifyAccount-selectAccount')}
                    immAccounts={accountsById}
                    accountsIndexes={accountsIndexes}
                    currentAccountId={destinationAccountId}
                    filterId={accountId}
                    onAccountChange={this.handleAccountChange}
                />
                {
                    immAuthorizationModifyAccount.get('errorAccount') &&
                    <div className="authorization-modify-account__step-1-error">
                        {formatText('authorizationModifyAccount-accountValidation')}
                    </div>
                }
            </div>
        )
    }

    renderStep2 = (accountInCharge, destinationAccountId, immAccounts, originAccountName) => {
        const account = immAccounts.getIn(['byId', destinationAccountId]);
        const destinationName = account.get('accountHolder');
        const alias = account.get('alias');
        const ibanFormatted = getLastNChars(account.get('iban'));
        const destinationAccountInCharge = alias + ibanFormatted;

        return (
            <div>
                <div className="authorization-modify-account__title">
                    <FormattedText value="authorizationModifyAccount-titleStep2" />
                </div>
                <div className="authorization-modify-account__text">
                    <FormattedText value="authorizationModifyAccount-textStep2" injectedStrings={[name]} />
                </div>
                <div className="authorization-modify-account__header-container">
                    {this.renderCurrentInfoAccount(accountInCharge, originAccountName)}
                    <OKInformativeList columns={3}>
                        <OKInformativeListItem
                            title={formatText('authorizationModifyAccount-destinationAccount')}
                            bodyText={destinationAccountInCharge}
                        />
                        <OKInformativeListItem
                            title={formatText('authorizationModifyAccount-beneficiaryName')}
                            bodyText={destinationName}
                        />
                        <OKInformativeListItem
                            title={formatText('authorizationModifyAccount-amount')}
                            bodyText={this.renderAmmount(account.get('balance'))}
                        />
                    </OKInformativeList>
                </div>
            </div>
        )
    }

    renderWizardSuccess = (exitLink) => {
        const goBackButton = {
            label: formatText('authorizationModifyAccount-backToDebits'),
            url: exitLink
        }
        return (
            <WizardSuccess
                successMessage={formatText('authorizationModifyAccount-title')}
                mainButton={goBackButton}
            >
                <p>
                    <FormattedText value="authorizationModifyAccount-success" />
                </p>
            </WizardSuccess>
        )
    }

    renderWizard = () => {
        const { immAuthorizationModifyAccount, match: { params: { accountId } } } = this.props;
        const errorReceived = immAuthorizationModifyAccount.get('errorReceived');
        const submitSuccessful = immAuthorizationModifyAccount.get('submitSuccessful');
        const exitLink = `/myprofile/accounts/${accountId}/debits`;
        if (submitSuccessful) {
            if (!errorReceived) {
                return this.renderWizardSuccess(exitLink);
            } else {
                return this.renderWizardError(exitLink);
            }
        } else {
            return this.renderWizardProgress();
        }
    }

    renderWizardProgress = () => {
        const {
            immAccount,
            immAccounts,
            immAuthorizationModifyAccount,
            setVisibleStep,
            validateStep,
            match: { params: { accountId } },
        } = this.props;
        const originAccountName = immAccount.get('accountHolder');
        const alias = immAccount.get('alias');
        const ibanFormatted = getLastNChars(immAccount.get('iban'));
        const accountInCharge = alias + ibanFormatted;
        const destinationAccountId = immAuthorizationModifyAccount.get('accountId');
        const steps = immAuthorizationModifyAccount.get('steps');
        const destinationAccount = immAccounts.getIn(['byId', destinationAccountId]);
        const stepsAmount = steps.size;
        const visibleStep = immAuthorizationModifyAccount.get('visibleStep');
        const actions = {
            cancel: this.handleCancel,
            finish: this.handleFinish,
            setWillCancel: (() => { }),
            setVisibleStep,
            validateStep,
        };
        const operationParams = {
            optional1: 'CTA',
            originAccount: this.getOriginAccountParam(destinationAccount)
        }

        return (
            <Wizard
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={steps}
                showPreLeaveModal={true}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                >
                    {
                        this.renderStep1(accountInCharge, immAccount, destinationAccountId, immAuthorizationModifyAccount, accountId, immAccounts, originAccountName)
                    }
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={'common-confirm'}
                >
                    {destinationAccountId && this.renderStep2(accountInCharge, destinationAccountId, immAccounts, originAccountName)}
                    <SignaturePattern
                        operationType={AUTHORIZATION_MODIFY_ACCOUNT}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    render() {
        const { immAccounts, match: { params: { accountId } } } = this.props;

        if (immAccounts && immAccounts.size) {
            return (
                <section className="authorization-modify-account">
                    <OKCover size="medium" section="accounts">
                        <OKHeaderSubPage
                            breadcrumbConfig={this.breadcrumb(accountId)}
                            finalTitle={getFinalTitle('landingHeader-authorizationModifyAccount')}
                        />
                    </OKCover>
                    <div className="authorization-modify-account__body">
                        <div>
                            {this.renderWizard()}
                        </div>
                    </div>
                </section>
            )
        } else {
            return null;
        }
    }
}
AuthorizationModifyAccount.propTypes = {
    changeSelectedAccount: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAuthorizations: PropTypes.object.isRequired,
    immAuthorizationModifyAccount: PropTypes.object.isRequired,
    modifyAcount: PropTypes.func.isRequired,
    modifyAccountReset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired
};

module.exports.constructor = AuthorizationModifyAccount;
module.exports.AuthorizationModifyAccount = connect(
    (state, ownProps) => ({
        immAccount: state.accounts.getIn(['byId', ownProps.match.params.accountId]),
        immAccounts: state.accounts,
        immAuthorizations: state.authorizations,
        immAuthorizationModifyAccount: state.authorizationModifyAccount,
    }),
    {
        changeSelectedAccount,
        modifyAcount,
        modifyAccountReset,
        setVisibleStep,
        validateAndExecuteSagas,
        validateStep
    }
)(withRouter(AuthorizationModifyAccount));
